import { t } from 'i18next';

export interface TenantJob {
    id: string;
    type: string;
    status: TenantJobStatusCodes;
    platformTenantId: string;
    ownerId: string;
    entityId: string;
    message: string;
    startedAt: string;
    completedAt: string;
    metadata: Record<string, unknown>;
    dateCreated: string;
}

export enum TenantJobStatusCodes {
    Pending = 0,
    InProgress = 1,
    Completed = 2,
    Failed = 3
}

export const TenantJobStatusLabels = {
    Completed: t('TenantJob.status.completed'),
    Failed: t('TenantJob.status.failed'),
    InProgress: t('TenantJob.status.inProgress'),
    Pending: t('TenantJob.status.pending')
};

export enum TenantJobType {
    Workato = 'workato'
}
